<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t("exam.exams") }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t("exam.list") }} </span>
          </h2>
        </div>
        <div class="section-header-right">
          <router-link :to="{ name: 'company.exam.add-demo' }">
            <button class="btn btn-default" type="button" aria-expanded="false">
              <i class="uil-plus"></i> {{ $t("exam.add") }}
            </button>
          </router-link>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <!-- <h4 class="d-inline-block mb-0"></h4> -->
            <!-- <div>
              <a
                href="javascript: void(0);"
                class="btn btn-icon btn-hover btn-circle"
                aria-expanded="false"
              >
                <i class="uil-search"></i>
              </a>
              <div
                class="uk-drop"
                uk-drop="mode: hover; pos: right-center; offset: 0"
                style="left: 91px; top: 159.297px"
              >
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input
                    class="uk-search-input shadow-0 uk-form-small"
                    type="search"
                    v-model="filter.search"
                    :placeholder="$t('general.search')"
                  />
                </form>
              </div>
            </div> -->
            <div class="uk-search uk-search-navbar">
              <i class="uil-search position-absolute"></i>
              <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                :placeholder="$t('general.search')" />
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a href="#" class="btn btn-icon btn-hover btn-circle" :uk-tooltip="$t('filters.sort_list')" title=""
                aria-expanded="false">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up" class="uk-dropdown">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('name', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('name', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_asc") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_desc") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading"
          style="position: absolute; height: 100%; width: 100%; z-index: 999; background: rgba(238, 238, 238, 0.5); display: flex; justify-content: center; align-items: center">
          <div uk-spinner="ratio: 4" class="text-info"></div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("exam.name") }}</th>
                <th scope="col">{{ $t("general.added_at") }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="exam in exams">
                <td>
                  <router-link :to="{
                    name: 'company.exam.edit-demo',
                    params: { id: exam.id },
                  }" class="name h6 mb-0 text-sm">
                    {{ exam.name }}
                  </router-link>
                </td>
                <td>{{ exam.created_at }}</td>
                <td class="text-right">
                  <!-- Actions -->
                  <div class="actions ml-3">

                    <router-link from="exam" :to="{
                      name: 'company.assignments.add',
                      params: { id: exam.content_id, title: exam.name, name: $t('exam.exam') }
                    }">
                      <button :disabled="!$hasPermission('create_assignment')"
                        :style="{ cursor: !$hasPermission('create_assignment') ? 'not-allowed' : 'pointer' }"
                        class="btn btn-default small" type="button" aria-expanded="false">
                        <i class="uil-location-arrow"> </i>{{ $t('menu.company_dashboard.create_assignment') }}
                      </button>
                    </router-link>
                    <!-- <router-link class="btn btn-icon btn-hover btn-sm btn-circle" :to="{
                        name: 'company.exam.edit',
                        params: { id: exam.id },
                      }" :uk-tooltip="$t('general.edit')" title="" aria-expanded="false">
                      <i class="uil-edit"></i>
                    </router-link> -->
                    <router-link class="btn btn-icon btn-hover btn-sm btn-circle" :to="{
                      name: 'company.exam.edit-demo',
                      params: { id: exam.id },
                    }" :uk-tooltip="$t('general.edit')" title="" aria-expanded="false">
                      <i class="uil-edit"></i>
                    </router-link>
                    <a :uk-tooltip="$t('general.exam_export_excell')" class="btn btn-icon btn-hover  btn-circle" href="javascript:;"
                      @click="exportExamQuestions(exam)">
                      <i class="uil uil-file-alt"></i>  
                    </a>
                    <a :disabled="!$hasPermission('delete_exam')"
                      :style="{ cursor: !$hasPermission('delete_exam') ? 'not-allowed' : 'pointer' }"
                      href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle"
                      :uk-tooltip="$t('general.delete')" title="" aria-expanded="false" @click="removeItem(exam.id)">
                      <i class="uil-trash text-danger"></i>
                    </a>

                    <a href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle"
                      :uk-tooltip="$t('general.preview')" title="" aria-expanded="false" @click="openPreviewModal(exam)">
                      <i class="uil-presentation-play"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
            @changePage="setPage($event)"></pagination>
        </div>
      </div>
    </div>

    <content-preview-modal ref="examContentPreviewModal" :selected-content="selectedContent"
      :preview-content="previewContentData" />

  </div>
</template>

<script>
import Vue from "vue";
import store from "@/core/services";
import moment from "moment";
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
  ITEMS,
  LOADING,
  ERROR,
  DELETE_ITEM,
} from "@/core/services/store/exam.module";
import Pagination from "@/assets/components/Pagination";
import { confirmDialogDelete } from "@/utils/confirmDialog";
import ContentPreviewModal from "@/view/components/modal/ContentPreviewModal.vue";
import axios from "axios";
export default {
  name: "examsList",
  components: { ContentPreviewModal, Pagination },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, module);
  },
  data() {
    return {
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      selectedContent: null,
      previewContentData: null,
    };
  },
  computed: {
    loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) { },
    },
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) { },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },
    exams() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items;

      for (let i = 0; i < this.items.data.length; i++) {
        let currentItem = this.items.data[i];
        if (currentItem) {
          results.push({
            id: currentItem.id,
            content_id: currentItem.content_id,
            name: currentItem.name,
            status_id: currentItem.status_id,
            created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          });
        }
      }
      return results;
    },
  },
  methods: {
    filterResult() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          like: this.filter.search,
          page: this.page,
          per_page: this.per_page,
          order: this.filter.order,
          sort: this.filter.sort,
        },
      });
    },
    exportExamQuestions(exam) {
      const examId = exam?.id;
      if (!examId) {
        return;
      }
      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL +
            `/api/exams/${examId}/questions-excel`,
          {
            params: { time: Date.now() },
            responseType: "blob",
            headers: this.apiHeaders,
          }
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHmmss");
          let fileName = `exam_questions_${examId}_${day}.xlsx`;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
    },
    async removeItem(id) {
      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        this.$store
          .dispatch(MODULE_NAME + "/" + DELETE_ITEM, {
            url: BASE_URL + "/" + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.filterResult();
            } else this.errorMessages.push(this.error);
          });
      }

    },
    sortOrder(sort, order) {
      let self = this;
      self.page = 1;
      self.filter.sort = sort;
      self.filter.order = order;
      this.filterResult();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.filterResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    async openPreviewModal(item) {
      try {
        const url = `/api/content/preview?content_id=${item.content_id}`;
        const response = await axios.get(url);

        let previewContent = null;

        if (response.data) {
          if (response.data.data) {
            previewContent = response.data.data;
          }
        }

        if (previewContent && this.$refs.examContentPreviewModal) {
          this.selectedContent = { ...item, id: item.content_id };
          this.previewContentData = previewContent;

          this.$refs.examContentPreviewModal.showModal();
        } else {
          console.error('No preview content or modal ref not found!');
        }
      } catch (error) {
        console.error('Error fetching preview data:', error);
      }
    },
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  mounted() {
    this.filterResult();
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
</style>
